"use client";
import * as React from 'react';
import { Box } from '../Box/Box.web.js';
import { FileListItem as FileListItem$1, FileNameLabel, AnimatedIconSwap } from './styles.js';
import { IconButton } from '../IconButton/IconButton.web.js';
import { LinearProgress } from '../LinearProgress/LinearProgress.web.js';
import { UploadStateName } from './types.js';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage.web.js';
import { ThemeProvider } from 'styled-components';
import { ContentText } from '../ContentText/ContentText.web.js';
import { IconCross } from '../icons/ui_control/IconCross.web.js';
import { IconCheck } from '../icons/ui_control/IconCheck.web.js';
import { IconFile } from '../icons/ui_file/IconFile.web.js';
import { useTheme } from '../utils/theming/useTheme.js';
import { spacing } from '../constants/spacing.js';
import { renderComponentOrElement } from '../utils/helpers/component.js';

var InnerContent = function InnerContent(props) {
  var _props$icon = props.icon,
    icon = _props$icon === undefined ? IconFile : _props$icon,
    state = props.state,
    name = props.name,
    disabled = props.disabled,
    removeIconAriaLabel = props.removeIconAriaLabel,
    handleRemove = props.handleRemove;
  var theme = useTheme();
  var actionIconColor = theme.colors.text;
  switch (state.name) {
    case UploadStateName.notStarted:
      {
        return /*#__PURE__*/React.createElement(FileListItem$1, {
          tabIndex: 0
        }, renderComponentOrElement(icon, {
          color: theme.fileUpload.web.inactiveText
        }), /*#__PURE__*/React.createElement(Box, {
          display: "flex",
          alignContent: "center",
          flexDirection: "column",
          flex: "1",
          ph: spacing.xxxs,
          overflow: "hidden"
        }, /*#__PURE__*/React.createElement(FileNameLabel, {
          size: "s",
          mb: spacing.xxxs,
          color: theme.fileUpload.web.inactiveText
        }, name)), /*#__PURE__*/React.createElement(IconButton, {
          status: "plain",
          "aria-label": removeIconAriaLabel,
          onClick: handleRemove,
          disabled: disabled,
          icon: /*#__PURE__*/React.createElement(IconCross, {
            color: actionIconColor
          })
        }));
      }
    case UploadStateName.started:
      {
        return /*#__PURE__*/React.createElement(FileListItem$1, {
          tabIndex: 0
        }, renderComponentOrElement(icon, {}), /*#__PURE__*/React.createElement(Box, {
          display: "flex",
          alignContent: "center",
          flexDirection: "column",
          flex: "1",
          ph: spacing.xxxs,
          overflow: "hidden"
        }, /*#__PURE__*/React.createElement(FileNameLabel, {
          size: "s",
          mb: spacing.xxxs
        }, name), /*#__PURE__*/React.createElement(LinearProgress, {
          mv: spacing.xxxxs,
          ariaLabel: "Upload progress",
          value: state.progress
        })));
      }
    case UploadStateName.completed:
      {
        return /*#__PURE__*/React.createElement(FileListItem$1, {
          tabIndex: 0
        }, renderComponentOrElement(icon, {}), /*#__PURE__*/React.createElement(Box, {
          display: "flex",
          alignContent: "center",
          flexDirection: "column",
          flex: "1",
          ph: spacing.xxxs,
          overflow: "hidden"
        }, /*#__PURE__*/React.createElement(FileNameLabel, {
          size: "s",
          mb: spacing.xxxs
        }, name)), /*#__PURE__*/React.createElement(AnimatedIconSwap, null, /*#__PURE__*/React.createElement(IconCheck, {
          color: theme.colors.primary
        }), /*#__PURE__*/React.createElement(IconButton, {
          status: "plain",
          "aria-label": removeIconAriaLabel,
          onClick: handleRemove,
          disabled: disabled,
          icon: /*#__PURE__*/React.createElement(IconCross, {
            color: actionIconColor
          })
        })));
      }
    case UploadStateName.failed:
      {
        return /*#__PURE__*/React.createElement(FileListItem$1, {
          tabIndex: 0,
          $hasError: true
        }, renderComponentOrElement(icon, {}), /*#__PURE__*/React.createElement(Box, {
          display: "flex",
          alignContent: "center",
          flexDirection: "column",
          flex: "1",
          ph: spacing.xxxs,
          overflow: "hidden"
        }, /*#__PURE__*/React.createElement(FileNameLabel, {
          size: "s",
          mb: spacing.xxxs
        }, name)), /*#__PURE__*/React.createElement(IconButton, {
          status: "plain",
          "aria-label": removeIconAriaLabel,
          onClick: handleRemove,
          disabled: disabled,
          icon: /*#__PURE__*/React.createElement(IconCross, {
            color: actionIconColor
          })
        }));
      }
  }
};
var FileListItem = function FileListItem(props) {
  var fileProp = props.file,
    onClickRemove = props.onClickRemove,
    _props$removeIconAria = props.removeIconAriaLabel,
    removeIconAriaLabel = _props$removeIconAria === undefined ? 'Remove file' : _props$removeIconAria,
    _props$disabled = props.disabled,
    disabled = _props$disabled === undefined ? false : _props$disabled,
    icon = props.icon;
  var name = fileProp.name,
    state = fileProp.state;
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Box, {
    key: name,
    tag: "li"
  }, /*#__PURE__*/React.createElement(InnerContent, {
    disabled: disabled,
    name: name,
    state: state,
    icon: icon,
    removeIconAriaLabel: removeIconAriaLabel,
    handleRemove: function handleRemove() {
      return onClickRemove && onClickRemove(fileProp);
    }
  }), /*#__PURE__*/React.createElement(ErrorMessage, {
    mb: spacing.xxs,
    active: state.name === UploadStateName.failed
  }, state.name === UploadStateName.failed && /*#__PURE__*/React.createElement(ContentText, null, state.message))));
};

export { FileListItem };
